const theme = require('sass-extract-loader?{"plugins": ["sass-extract-js"]}!styles/settings/variables_jsx.scss');
export default theme;